import type { IconData } from '@stacksjs/iconify-core'

export const cloudDataTransfer: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M16 38.887q-.851-.026-1.63-.057C7.768 38.57 3 34.107 3 27.5c0-5.437 3.228-9.42 8.05-10.807c.527-6.778 5.164-11.64 12.173-11.69a110 110 0 0 1 1.554 0c7.009.05 11.646 4.912 12.173 11.69C41.772 18.08 45 22.063 45 27.5c0 5.032-2.765 8.819-7 10.455\"/><path d=\"M21 43V25l-6 6m12-6v18l6-6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cloudDataTransfer
